import { AssistantStreamEvent } from "@cloudserver/contracts";

/*
 * Reads the assistant's answer stream (`POST …/messages`, text/event-stream;
 * docs/assistant.md). EventSource cannot POST, so the panel reads the body
 * itself: chunks arrive in any size and are cut into events at blank lines.
 * Comment lines (heartbeats) and events we do not know are skipped.
 */

export function createSseParser(onEvent: (event: AssistantStreamEvent) => void) {
  let buffer = "";
  return (chunk: string): void => {
    buffer = (buffer + chunk).replace(/\r\n/g, "\n");
    for (let end = buffer.indexOf("\n\n"); end >= 0; end = buffer.indexOf("\n\n")) {
      const block = buffer.slice(0, end);
      buffer = buffer.slice(end + 2);
      const data = block
        .split("\n")
        .filter((line) => line.startsWith("data:"))
        .map((line) => line.slice(5).replace(/^ /, ""))
        .join("\n");
      if (!data) continue;
      let json: unknown;
      try {
        json = JSON.parse(data);
      } catch {
        continue;
      }
      const parsed = AssistantStreamEvent.safeParse(json);
      if (parsed.success) onEvent(parsed.data);
    }
  };
}
